"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const Mutation = __importStar(require("./mutation"));
const Query = __importStar(require("./query"));
const Subscription = __importStar(require("./subscription"));
exports.default = { Mutation, Query, Subscription };
__export(require("./input"));
__export(require("./jwt"));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEscURBQXNDO0FBQ3RDLCtDQUFnQztBQUNoQyw2REFBOEM7QUFDOUMsa0JBQWUsRUFBQyxRQUFRLEVBQUUsS0FBSyxFQUFFLFlBQVksRUFBQyxDQUFBO0FBRTlDLDZCQUF1QjtBQUN2QiwyQkFBcUIifQ==